'use client';

// Vangnet wanneer de root layout zelf crasht: Mantine is hier niet
// beschikbaar, dus alleen inline styling en een harde reload als retry.

import { useEffect } from 'react';
import { reportError } from '@/lib/telemetry';

export default function GlobalError({ error, reset }) {
  useEffect(() => {
    reportError(error, { source: 'global-error-boundary' });
  }, [error]);

  return (
    <html lang="en">
      <body style={{ margin: 0, fontFamily: 'system-ui, sans-serif', background: '#f8f9fa' }}>
        <div
          role="alert"
          style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 16,
            padding: 24,
            textAlign: 'center',
          }}
        >
          <h1 style={{ margin: 0, fontSize: 24 }}>Something went wrong</h1>
          <p style={{ margin: 0, color: '#66707a', maxWidth: 420 }}>
            The page failed to load. Please try again, or come back in a moment.
          </p>
          <button
            onClick={reset}
            style={{
              padding: '10px 24px',
              borderRadius: 24,
              border: 'none',
              background: '#228be6',
              color: '#fff',
              fontSize: 15,
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            Try again
          </button>
        </div>
      </body>
    </html>
  );
}
